import {
  DNA_ABOUT,
  PUBLICATIONS_DNA,
  STORIES_DNA,
} from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './DnaAbout'

export default withLocalization(Component, DNA_ABOUT, {
  publications: PUBLICATIONS_DNA,
  stories: STORIES_DNA,
})
